import { render, staticRenderFns } from "./ErSection.vue?vue&type=template&id=86f776ce&scoped=true&"
import script from "./ErSection.vue?vue&type=script&lang=js&"
export * from "./ErSection.vue?vue&type=script&lang=js&"
import style0 from "./ErSection.vue?vue&type=style&index=0&id=86f776ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f776ce",
  null
  
)

export default component.exports